import React from 'react';
import {useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';

import NavigationItem from "./NavigationItem/NavigationItem";
import logoIcon from "../../../assets/images/hackernews_logo.gif";
import "./NavigationItems.css"

const NavigationItems = (props) => {

    const isAuth = useSelector(state => state.auth.token !== null)
    const username = useSelector(state => state.auth.username)
    const userId = useSelector(state => state.auth.userId)

    const pathname = props.location.pathname.substring(1)

    return (
        <div className="NavigationItems">
            <div className="Left">
                <NavigationItem link="/">
                    <img src={logoIcon} alt=""/>
                </NavigationItem>
                <NavigationItem link="/news">
                    <b style={{color: "black"}}>
                        Hacker News
                    </b>
                </NavigationItem>
                <div className="divider">|</div>
                <NavigationItem link="/newest">new</NavigationItem>
                <div className="divider">|</div>
                <NavigationItem link="/comments">comments</NavigationItem>
                <div className="divider">|</div>
                <NavigationItem link="/submit">submit</NavigationItem>
            </div>
            <div className="Right">
                {isAuth ? (
                    <>
                        <NavigationItem link={{
                            pathname: "/user",
                            search: "?userId=" + userId
                        }}>{username}</NavigationItem>
                        <div className="divider">|</div>
                        <NavigationItem link={{
                            pathname: "/logout",
                            search: "?goto=" + pathname + props.location.search
                        }}>logout</NavigationItem>
                    </>
                ) : (
                    <NavigationItem link={{
                        pathname: "/auth",
                        search: (pathname === 'auth' || pathname ==='' ? ""
                            : "?goto=" + pathname)
                            + props.location.search
                    }}>login</NavigationItem>
                )}
            </div>
        </div>
    )
}

export default withRouter(NavigationItems);